export const CHECKOUT_LABELS = 'checkout';
export const GLOBAL_LABELS = 'global';
export const ACCOUNT_LABELS = 'global';

const unavailableErrorCopy = 'Choose a different color, fit, size or store';

const CartItemTileLabels = {
  checkout: {
    bagPage: {
      lbl_sfl_maxLimitError:
        'Sorry you have reached the max number of items that can be saved for later.',
      lbl_pre_order_tag: 'Pre Order',
      lbl_sfl_moveToBag: 'Move To Bag',
      lbl_Pts_cartTile: 'Pts',
      lbl_Qty_cartTile: 'Qty',
      lbl_boss_unavailable_item_level_error: 'Unavailable for No-Rush Pickup.',
      lbl_boss_unavailable_item_level_error2:
        'Select Ship to Home and get it delivered to your door!',
      lbl_extended_preOrder_msg: 'Limited payment methods',
      lbl_extended_preOrder_toolTip_msg:
        'Due to the extended timeframe of this pre-order item, we are unable to accept PayPal, Afterpay, Apple Pay and Venmo payments.',
      lbl_low_invetory_cart_tile: 'Only [val] left in stock - order soon.',
      lbl_low_invetory_threshold_ship_to_home: '13',
      lbl_low_invetory_threshold_BOPIS: '10',
      lbl_low_invetory_threshold_BOSS: '12',
      lbl_low_invetory_threshold_SFL: '11',
      lbl_freeShipping_cartTile: 'Free Shipping',
      lbl_couponlist_lessMoreTxt: 'Show less',
      lbl_preorder_items_edd: '*Pre-order items expected to ship by',
      lbl_social_proofing_msg:
        'PLACE Bucks ends TODAY - <span class="social-proof-checkout-msg">spend them now!</span>',
      lbl_boss_unavailable_global_error_subtext: 'ship them home',
    },
  },
  global: {
    cartItemTile: {
      lbl_cartTile_bopis: 'I’ll pick up in store at #store# Today',
      lbl_cartTile_boss:
        'I’ll pick up in store at #store# by #startMonth# #startdate# - #endMonth# #enddate#',
      lbl_cartTile_pickUpToday: 'Pick Up Today',
      lbl_cartTile_shipToHome: 'Ship to Home',
      list_price_suffix: 'each',
      lbl_cartTile_soldOut: 'This item is sold out',
      lbl_cartTile_bossInEligible: 'This item is unavailable for ship to store',
      lbl_cartTile_productImageAlt: 'Product',
      lbl_cartTile_changeStore: 'Change Store',
      lbl_cartTile_bopis_pickUp: 'Pick Up',
      lbl_not_available: 'Not available',
      lbl_get_it_today: 'Get it today!',
      lbl_edd_placeholdeer_boss: '5 to 15 days',
      lbl_total_savings: 'Total Savings',
      lbl_item_promotion: 'Limited-Time Savings',
      lbl_offer_applied: 'offer(s) applied!',
      lbl_offer_applied_new: 'offer(s) applied',
      lbl_offer_available: 'offer(s) available',
      lbl_cartTile_notAvailableOnlineOnly: 'Not available (Online Only)',
      lbl_cartTile_notAvailableClearanceItem: 'Not available (Clearance Item)',
      lbl_cartTile_bossUnavailable: unavailableErrorCopy,
      lbl_cartTile_bossReqQtyUnavailable: 'Choose a different color, fit, size, qty or store',
      lbl_cartTile_bopisUnavailable: unavailableErrorCopy,
      lbl_cartTile_ecomUnavailable: unavailableErrorCopy,
      lbl_accessory_price_included: 'Included',
      lbl_view_all: 'View All',
      lbl_cartTile_at: 'At',
      lbl_cartTile_noRushPickup: 'NO RUSH Pick Up',
      lbl_cartTile_onHold_Coupon: 'This item is not eligible for ',
    },
    addedToBagModal: {
      lbl_info_color: 'Color',
      lbl_info_price: 'Price',
      lbl_info_size: 'Size',
      lbl_info_Qty: 'Qty',
      lbl_info_giftValue: 'Value',
    },
    minibag: {
      lbl_eligibleQty_error: 'Quantity Should be greater than MainProduct Quantity',
      lbl_backPack_alone_error: 'Item cannot be bought alone.',
      lbl_backPack_alone_error_3: 'to add an accessory before checking out.',
      lbl_backPack_alone_error_2: ' Click here ',
      lbl_cart_someItemUnavailable: 'Some of the item(s) are unavailable.',
      lbl_miniBag_itemUnavailable: 'This item is unavailable',
      lbl_miniBag_soldOut: 'SOLD OUT',
      lbl_minibag_errorRemoveSoldoutHeader:
        'One or more items in your bag are sold out. Please #remove# the sold out item(s) from your bag before you check out.',
      lbl_minibag_errorUpdateUnavailable:
        'One or more items in your bag are unavailable for your selected options. Please edit your selection or #remove# the unavailable item(s) from your bag before you check out.',
      lbl_minibag_errorRemove: 'remove',
      lbl_minibag_errorSize: 'Please select a size',
    },
  },
  account: {
    orders: {
      lbl_orderDetails_itemnumber: 'Item# ',
    },
  },
  Browse: {
    QuickView: {
      lbl_edit_item: 'Edit Item',
    },
    ProductPickup: {
      lbl_Product_pickup_CHANGE_STORE_DM: 'Change Store',
    },
  },
};

export default CartItemTileLabels;
